import {
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  Paper,
  SvgIconProps,
  type PaperProps,
} from '@mui/material';

import React, { FC } from 'react';
import { LazyImage } from '~/components/LazyImage';

interface SummaryCardProps extends Omit<PaperProps, 'title'> {
  icon?: React.ReactElement<SvgIconProps>;
  image?: string;
  title?: string | React.ReactElement;
  subtitle?: string | number | React.ReactElement;
  action?: React.ReactElement;
}

export const SummaryCard: FC<SummaryCardProps> = ({
  icon,
  title,
  image,
  action,
  subtitle,
  ...paperProps
}) => {
  return (
    <Paper
      variant="outlined"
      square
      elevation={0}
      className={`summary-card`}
      {...paperProps}
      sx={{ width: '100%', ...paperProps?.sx }}>
      <ListItem alignItems="center" secondaryAction={action}>
        {image && (
          <ListItemAvatar>
            <LazyImage src={image} height="40" width="40" alt="" />
          </ListItemAvatar>
        )}
        {icon && <ListItemIcon>{icon}</ListItemIcon>}

        <ListItemText sx={{ mb: 0 }} primary={title} secondary={subtitle} />
      </ListItem>
    </Paper>
  );
};
